module.exports = __webpack_public_path__ + "img/index_zhjx.e751f84f.svg";